module.exports = __webpack_public_path__ + "img/子宫内膜癌.fd8aa666.png";